import { FC } from 'react';
import { isAdminApp } from '~/public/lib/PageHelpers';

const HiddenQuestion: FC = ({ label, value, setValue, settings }) => {
    if (isAdminApp()) {
        return (
            <div className="text-gray-500">
                {label}: This won't show to clients and can be passed in via the
                URL
            </div>
        );
    }

    return null;
};

export default HiddenQuestion;
